import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { GlobalConfigurationEntity } from "../../types/GlobalConfigurationEntity";
import { GlobalConfigurationDtoToEntity } from "../mappers/GlobalConfigurationDtoToEntity";
import { GlobalConfigurationEntityToDto } from "../mappers/GlobalConfigurationEntityToDto";

const GlobalConfigurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        GlobalConfigurationLoad: builder.query<GlobalConfigurationEntity, void>({
            providesTags: [ResourceName.GLOBAL_CONFIGURATIONS],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.GLOBAL_CONFIGURATIONS}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return GlobalConfigurationDtoToEntity(response);
            },
        }),
        GlobalConfigurationUpdate: builder.mutation<GlobalConfigurationEntity, FormMutation<GlobalConfigurationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.GLOBAL_CONFIGURATIONS}/${mutation.data.id}`;
                const method = "PUT";

                const body = GlobalConfigurationEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.GLOBAL_CONFIGURATIONS],
        }),
    }),
});

export const { useGlobalConfigurationLoadQuery, useGlobalConfigurationUpdateMutation } = GlobalConfigurationApi;
